import { render, staticRenderFns } from "./ReportHistoryDetail.vue?vue&type=template&id=35dc49bc&scoped=true&"
import script from "./ReportHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./ReportHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportHistoryDetail.vue?vue&type=style&index=0&id=35dc49bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc49bc",
  null
  
)

export default component.exports